<mobi-breadcrumb />
@if (entity().headerImages) {
  <mobi-hero-v-images
    class="block mobi-ui-margin-t-sm"
    [superTitle]="entity().superTitle"
    [subtitle]="entity().subtitle"
    [title]="entity().title"
    [lead]="entity().lead"
    [contentLinks]="contentLinks()"
    [headerImages]="entity().headerImages"
    [primaryCta]="entity().cta"
    [primaryCtaIcon]="entity().ctaIcon"
  />
}

@if (entity().paragraphs) {
  <div class="page-content is-background">
    @for (paragraph of entity().paragraphs; track paragraph?.uuid ?? $index) {
      @if (paragraph) {
        <mobi-paragraph-loader
          [bundle]="paragraph.type"
          [data]="{ paragraph: paragraph }"
        />
      }
    }
  </div>
}
